import { render, staticRenderFns } from "./modal-legal.vue?vue&type=template&id=26e2445e&scoped=true"
import script from "./modal-legal.vue?vue&type=script&lang=js"
export * from "./modal-legal.vue?vue&type=script&lang=js"
import style0 from "./modal-legal.vue?vue&type=style&index=0&id=26e2445e&prod&scoped=true&lang=css"
import style1 from "./modal-legal.vue?vue&type=style&index=1&id=26e2445e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e2445e",
  null
  
)

export default component.exports